import { render } from "./ModalDocumentRoles.vue?vue&type=template&id=20904b96&scoped=true"
import script from "./ModalDocumentRoles.vue?vue&type=script&lang=js"
export * from "./ModalDocumentRoles.vue?vue&type=script&lang=js"

import "./ModalDocumentRoles.vue?vue&type=style&index=0&id=20904b96&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20904b96"]])

export default __exports__